module.exports = __webpack_public_path__ + "media/images/companyPage/environment-03581e4db1b6e88e0ffa23f543d62b25.svg";